<template>
<div class="container" :class="IOSContainer">
  <!--公告区通知条-->
  <z-notice-bar
    :text="announcementConfig.topMessage"
    v-show="showNoticeBar"
    mode="closeable"
    class="noticeBar-container"
  >
    <p @click="handleShowNoticePopup" zz-sectionid="101" zz-sortid="0" zz-sortname="通知条">{{announcementConfig.topMessage}}</p>
  </z-notice-bar>
     <!--宣传区-->
    <advertise :advertise="advertiseConfig" zz-sectionid="102" />
    <!--问候区-->
    <greeting :greeting="greetingDto"/>
    <!--业务分类区-->
    <biz-category
      zz-sectionid="103"
      v-show="showBusinessCate"
      @changeBizCate="handleChangeBizCate"
      :curBizCate="curBizCate"
      :bizCateList="businessInfoList"
      needRedBorder
    />
    <!--推荐订单区-->
    <recommand-order
      zz-sectionid="104"
      data-areaexposure="107"
      data-isdot="1"
      :skillId="skillId"
      :athenaChannel="athenaChannel"
      v-show="hasRecommandOrder"
      :recommandOrderInfo="userAnswerDto"
      :curBizCate="curBizCate"
    />
    <!--推荐问题区-->
    <recommand-questions
      zz-sectionid="105"
      v-show="showRecommandQuestion"
      :skillId="skillId"
      :key="getUnicKey()"
      :athenaChannel="athenaChannel"
      :questionCateList="questionDtoList"
      :curBizCate="curBizCate"
    />
    <!--切换业务线-->
    <!-- <div class="change-bizcate-tip" v-show="hasRecommandOrder">
      沟通过程中，若需咨询不同业务的问题，可以点击
      <span @click="handleTogglePopup" class="change-bizcate-tip-btn">切换业务</span>
    </div> -->
    <!--切换业务-->
    <z-popup v-model="popupVisible" position="bottom">
      <header class="popup-header">请选择你要咨询的业务</header>
      <div v-if="this.businessInfoList.length">
        <biz-category
          @changeBizCate="handleChangeBizCate"
          :curBizCate="curBizCate"
          :bizCateList="businessInfoList"
          bigFontSize
        />
        <div class="popup-cancel-btn" @click="handleTogglePopup">取消</div>
      </div>
      <z-stance
        v-else
        type="general"
        :show-info="false"
        descText="您可切换的业务空空如也"
      />
    </z-popup>
    <!--公告区弹窗-->
    <z-popup
      zz-popupname="公告区弹窗"
      v-model="noticeVisible"
      position="center"
      class="dialog-msg-container"
    >
      <header class="dialog-msg-header">公告</header>
      <div class="dialog-msg-content" v-html="noticeContent"/>
      <z-button zz-sortId="0" zz-sortname="公告-我知道了" zz-popupname="公告区弹窗" size="normal" type="primary" @click="handleCloseNotice">我知道了</z-button>
    </z-popup>
    <z-button-group fixed class="bottom-btn">
      <!--当页面数据没有加载出来前，按钮不可用-->
      <z-button
        size="normal"
        :disabled="loading"
        zz-sectionid="108"
        zz-sortid="0"
        zz-sortname="在线客服"
        @click="goToService"
      >
      在线客服
      </z-button>
    </z-button-group>
  <!--自助服务区-->
  <self-service :selfServiceList="selfServiceConfig.selfServiceDetails" zz-sectionid="106" />
</div>
</template>

<script>
import { Button, ButtonGroup, Popup, NoticeBar, Stance, Toast } from '@zz-common/zz-ui';
import native from '@zz-common/native-adapter'
import { ulid } from 'ulid'
import { getCustomerCenterResult, apiKfcenterBusinessFilter } from '@api/resourceApi'
import { queryParams, detectOS, isZlj, hideShareButton, getCookie } from '../../lib/utils'
import Advertise from './Advertise'
import BizCategory from './BizCategory'
import Greeting from './Greeting'
import RecommandOrder from './RecommandOrder'
import SelfService from './SelfService'
import RecommandQuestions from './RecommandQuestions'
import { lego, legoAreaExposure } from '@zz-common/lego'

const query = queryParams()

export default {
  name: 'newHelpCenter',
  data() {
    return {
      loading: false, // 页面加载状态
      skillId: query.skillId || this.$route.query.skillId, // 技能组ID
      athenaChannel: query.athenaChannel || this.$route.query.athenaChannel, // 雅典娜渠道号
      imUrl: 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?', // im地址
      popupVisible: false,
      noticeVisible: false,
      curBizCate: {}, // 当前选中的业务分类
      greetingDto: {}, // 问候
      announcementConfig: {}, // 公告
      advertiseConfig: {}, // 宣 传
      selfServiceConfig: {}, // 自助服务
      businessInfoList: [], // 业务分类
      questionDtoList: [], // 推荐问题
      userAnswerDto: {}, // 推荐订单
      businessId: ''// 起初锚定的业务
    }
  },
  computed: {
    IOSContainer() {
      const { ios } = detectOS()
      const Zlj = isZlj()
      let styleName = ''
      if (ios && !Zlj) {
        styleName = 'IOSContainer'
      } else if (ios && Zlj) {
        styleName = 'zljContainer'
      }
      console.log('Zlj', Zlj, 'ios', ios, styleName)
      return styleName
    },
    noticeDetail() {
      return this.notice.data.detail || ''
    },
    skipImUrl() {
      console.log('sdfasdfads', this.skillId, this.athenaChannel, this.curBizCate.businessCategoryId)
      return `${this.imUrl}skillId=${this.skillId}&athenaChannel=${this.athenaChannel}&businessId=${this.curBizCate.businessCategoryId}`
    },
    showNoticeBar() {
      return this.announcementConfig.switchFlag === '1'
    },
    showBusinessCate() {
      return this.businessInfoList.length
    },
    hasRecommandOrder() {
      if (this.userAnswerDto.orderInfo) {
        legoAreaExposure()
      }
      return this.userAnswerDto.orderInfo
    },
    showRecommandQuestion() {
      return this.questionDtoList.length && !this.userAnswerDto.orderInfo
    },
    noticeContent() {
      return this.announcementConfig.detailDesc
    }
  },
  methods: {
    getUnicKey() {
      return ulid()
    },
    handleShowNoticePopup(_e) {
      this.noticeVisible = true
    },
    handleCloseNotice() {
      this.noticeVisible = false
    },
    getHelpCenterInfo(params, cb) {
      const loadingToast = Toast.loading({ // 加载loading
        forbidClick: true,
        duration: 1000,
        message: '正在加载'
      });
      // 修改页面加载状态
      this.loading = true
      getCustomerCenterResult(params)
        .then((res) => {
          // console.log('getHelpCenterInfo>>>>', res)
          loadingToast.clear() // 清除toast实例
          this.loading = false
          if (res) {
            const {
              advertiseConfig = {},
              announcementConfig = {},
              businessInfoList = {},
              greetingDto = {},
              questionDtoList = [],
              selfServiceConfig = {},
              userAnswerDto,
              businessId = ''
            } = res
            this.advertiseConfig = advertiseConfig
            this.announcementConfig = announcementConfig
            this.greetingDto = greetingDto
            this.questionDtoList = questionDtoList
            this.selfServiceConfig = selfServiceConfig
            this.userAnswerDto = userAnswerDto
            this.businessId = businessId
            this.businessInfoList = businessInfoList
            apiKfcenterBusinessFilter({ keys: 'kfcenterBusinessFilter', timeStamp: Date.now() }).then(res => {
              if (res.respCode == 0) {
                const filterData = (res.respData?.businessId || [])
                this.businessInfoList = businessInfoList.filter(it => !filterData.some(filterItem => filterItem == it.businessCategoryId))
              } else {
                this.businessInfoList = businessInfoList
              }
            }).finally(() => {
              if (cb) { // 执行回调
                cb()
              }
            })
          }
        })
    },
    goToService() { // 跳转至IM
      // 防止跳转至新页面的时候携带的参数出现undefined
      // 故在页面数据请求时不可跳转
      if (!this.loading) {
        lego.send({
          pagetype: 'ZZUP_NEWHELPCENTER',
          actiontype: 'NEWHELPCENTER_BTMBTN_GOTOSERVICE',
          backup: {
            businessCategoryId: this.curBizCate.businessCategoryId
          }
        })
        native.skipToUrl({
          targetUrl: this.skipImUrl
        });
      }
    },
    handleChangeBizCate(bizCate) { // 切换业务线，重新请求数据
      if (this.popupVisible) {
        this.popupVisible = false
      }
      this.curBizCate = bizCate
      lego.send({
        pagetype: 'ZZUP_NEWHELPCENTER',
        actiontype: 'NEWHELPCENTER_BIZCATEGORY_CHANGEBIZCATE_CLICK',
        backup: {
          businessId: this.curBizCate.businessCategoryId
        }
      })
      this.getHelpCenterInfo({
        channelId: this.athenaChannel,
        businessId: this.curBizCate.businessCategoryId
      })
    },
    handleTogglePopup() {
      this.popupVisible = !this.popupVisible
    },
    init() {
      hideShareButton()
      native.setTitle({
        title: '客服中心'
      })
      this.getHelpCenterInfo({ channelId: this.athenaChannel },
        () => {
          this.$nextTick(() => { // 初始选中的业务
            if (this.businessInfoList.length) {
              const tempBizCate = this.businessInfoList.find(it => it.businessCategoryId == this.businessId)
              this.curBizCate = tempBizCate || this.businessInfoList[0]
              lego.send({
                pagetype: 'ZZUP_NEWHELPCENTER',
                actiontype: 'NEWHELPCENTER_BIZCATEGORY_INIT_BIZCATE_CLICK',
                backup: {
                  name: this.curBizCate.businessCategoryId
                }
              })
            }
          })
        })
      apiKfcenterBusinessFilter({ keys: 'mossKfCenter', timeStamp: Date.now() }).then((res) => {
        if (res?.zljopen) { // 白名单是否开启
          const uidList = res?.zljuidList || [] // 获取白名单uid列表
          if (uidList.includes(getCookie('uid'))) {
            // 跳转新moss渠道的客服中心
            native.skipToUrl({
              targetUrl: 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10115&athenaChannel=10125#/NewHome',
              needClose: '1'
            })
          }
        }
      })
    }
  },
  components: {
    Advertise,
    BizCategory,
    Greeting,
    SelfService,
    RecommandOrder,
    RecommandQuestions,
    zButton: Button,
    zButtonGroup: ButtonGroup,
    zPopup: Popup,
    zNoticeBar: NoticeBar,
    zStance: Stance
  },
  mounted() {
    this.init()
  }
}

</script>
<style lang="less" scoped>
  @import 'index.less';
</style>